import {SOPutSimpleAttribute} from '../../core/simple-attribute/so-put-simple-attribute';
import {SimpleAttributeCore} from './simple-attribute.core';
import {SOGetSimpleAttribute} from '../../core/simple-attribute/so-get-simple-attribute';
import {FormField, SelectionOption} from 'lionheartland';
import {putSimpleAttributeFormFieldOptions} from './put-simple-attribute-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {SimpleAttributePermissionRuleCore} from '../simple-attribute-permission-rule/simple-attribute-permission-rule.core';
import {SOGetSimpleAttributePermissionRule} from '../../core/simple-attribute-permission-rule/so-get-simple-attribute-permission-rule';
import {EntityCore} from '../entity/entity.core';
import {SOGetEntity} from '../../core/entity/so-get-entity';
import {CustomLogicRequirementCore} from '../custom-logic-requirement/custom-logic-requirement.core';
import {SOGetCustomLogicRequirement} from '../../core/custom-logic-requirement/so-get-custom-logic-requirement';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutSimpleAttribute extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putSimpleAttributeFormFieldOptions);

  RequestClass = SOPutSimpleAttribute

  constructor(
    public entityCore: SimpleAttributeCore
  ) {
    super();
    if (putSimpleAttributeFormFieldOptions.simpleAttributePermissionRules) {
      putSimpleAttributeFormFieldOptions.simpleAttributePermissionRules.makeCore = true;
    }
    if (putSimpleAttributeFormFieldOptions.entity) {
      putSimpleAttributeFormFieldOptions.entity.makeCore = true;
    }
    if (putSimpleAttributeFormFieldOptions.customLogicRequirement) {
      putSimpleAttributeFormFieldOptions.customLogicRequirement.makeCore = true;
    }
    if (putSimpleAttributeFormFieldOptions.project) {
      putSimpleAttributeFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('attributeType'),
      this.getFormValueFromIdentifier('editPermissions'),
      [this.getFormValueFromIdentifier('simpleAttributePermissionRules', SOGetSimpleAttributePermissionRule)],
      this.getFormValueFromIdentifier(
        'entity',
        SOGetEntity,
      ),
      this.getFormValueFromIdentifier(
        'customLogicRequirement',
        SOGetCustomLogicRequirement,
      ),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}